import { Text } from "@mantine/core";
import { PageHeader } from "../../components/pages/page-header/PageHeader";
import { MyH1 } from "../../components/UI/my-h1/MyH1";
import { BlogList } from "../../components/pages/blog/BlogList";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { isPhone } from "../../constants/env";
import { MyHead } from "../../components/pages/MyHead";
import { Fragment } from "react";
import { ArticleList } from "../../components/pages/useful-articles/article-list";
import { Footer } from "../../components/pages/homepage/footer/Footer";

// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  };
}

export default function UsefulArticlePage() {
  const { t } = useTranslation("common");

  return (
    <Fragment>
      <MyHead
        title={t("useful-articles.name")}
        description={t("useful-articles.description")}
      />
      <PageHeader>
        <div className="text-center">
          <MyH1
            size={isPhone ? "2.5rem" : "3rem"}
            className="text-center"
            color="white"
          >
            {t("useful-articles.name")}
          </MyH1>
          <Text className="!text-white text-[22px] font-bold">
            {t("useful-articles.description")}
          </Text>
        </div>
      </PageHeader>
      <ArticleList />
      <Footer isVisible />
    </Fragment>
  );
}
